export default "__VITE_ASSET__CKMij7l5__"